import { Checkbox, Typography } from '@material-ui/core';
import { LoadingSpinnerIconTwoTone } from '@room-match/shared-ui-components';
import { ProfileListCheckBoxProps } from 'pages/MyLinks/types';
import { ProfileCheckBoxContainer, CheckBoxContainer, AbsouluteContainer } from './ProfileListCheckBox.styles';
import { FC } from 'react';

const ProfileCheckBox: FC<ProfileListCheckBoxProps> = ({
  check,
  isUpdating,
  selectedBox,
  profileLink,
  isPublished,
  selectedPrimary,
}) => {
  return (
    <ProfileCheckBoxContainer>
      <CheckBoxContainer>
        <AbsouluteContainer>
          {isUpdating && selectedBox === check?.key ? (
            <LoadingSpinnerIconTwoTone style={{ marginTop: '7px', marginLeft: '7px' }} fontSize="inherit" />
          ) : (
            <Checkbox
              onChange={check?.onClick}
              checked={check?.checked}
              color="primary"
              size="small"
              disabled={(selectedPrimary === profileLink?.id && check?.name === 'Primary') || !isPublished}
            />
          )}
        </AbsouluteContainer>
      </CheckBoxContainer>
      <Typography style={{ fontSize: 11 }}>{check.name}</Typography>
    </ProfileCheckBoxContainer>
  );
};

export default ProfileCheckBox;
